import React from 'react';
import { BLOCKS } from '@contentful/rich-text-types';
import { RenderNode } from '@contentful/rich-text-react-renderer';

import { IBlogPostFields } from '../../../types/contentful';

import { getImageData } from '../../utils/contentful';

import { BlockContainer, Layout, BoxColumn } from '../Layout';
import RichText from '../RichText';
import { EmbeddedEntryNode } from '../RichText/Nodes';

import { UnorderedList, BlogImage, BlogImagePositioner } from './styles';

export function BlogPostBody({ body }: IBlogPostFields) {
  if (!body) return null;

  const RICH_TEXT_OVERRIDES: RenderNode = {
    [BLOCKS.UL_LIST]: (_node, children) => (
      <UnorderedList>{children}</UnorderedList>
    ),
    [BLOCKS.EMBEDDED_ENTRY]: (node, children) => (
      <EmbeddedEntryNode node={node} colour="defaultText">
        {children}
      </EmbeddedEntryNode>
    ),
    [BLOCKS.EMBEDDED_ASSET]: (node) => (
      <BlogImagePositioner>
        <BlogImage {...getImageData(node.data.target)} />
      </BlogImagePositioner>
    )
  };

  return (
    <BlockContainer
      marginTop={{ 0: 'm', tablet: 'ml' }}
      marginBottom={{ 0: 'ml', tablet: 'l', desktop: 'xl' }}
      data-testid="blog-post-body"
    >
      <Layout gutter={{ 0: 'ml', tablet: 'm', desktop: 'xl' }}>
        <BoxColumn size={{ 0: 10, desktop: 8 }}>
          <RichText data={body} overrideOptions={RICH_TEXT_OVERRIDES} />
        </BoxColumn>
      </Layout>
    </BlockContainer>
  );
}
